import { Injectable } from '@angular/core';
import { FidelityPageService } from 'app/core/services/fidelity-page.service';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResult } from '../types/api-result.types';
import { LegalDocumentData } from './legal-documents.types';

@Injectable({
    providedIn: 'root',
})
export class LegalDocumentsService extends FidelityPageService {
    legalDocsCacheKey = `${this.constructor.name}`;

    getLegalDocumentsForCustomerOperations(lang: string): Observable<ApiResult<LegalDocumentData[]>> {
        const cacheKey = `${this.legalDocsCacheKey}-${lang}`;
        if (this.memoryCacheService.has(cacheKey)) {
            return of(this.memoryCacheService.get(cacheKey));
        }
        const params = {
            lang: lang,
        };

        return this.http.get<ApiResult<LegalDocumentData[]>>(`${environment.apiUrl}/legal-docs`, { params }).pipe(
            catchError(this.handleError),
            tap((res) => {
                this.memoryCacheService.set(cacheKey, res);
            })
        );
    }
}
